import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpComponentsListComponent from './adpComponentsList.component';

let adpComponentsListModule = angular.module('adpComponentsList', [
  uiRouter
])

.component('adpComponentsList', adpComponentsListComponent)

.name;

export default adpComponentsListModule;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentsList/adpComponentsList.js